import styled from 'styled-components';

export const Bar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 12px;
  padding: 6px 12px;
  font-size: 13px;
`;

export const Name = styled.span`
  font-weight: 650;
`;

export const Stat = styled.span`
  color: var(--muted);

  & b {
    color: var(--ink);
    font-weight: 600;
  }
`;

export const Pips = styled.span`
  display: inline-flex;
  gap: 3px;
  margin-left: 2px;
  vertical-align: middle;
`;

export const Pip = styled.i`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${props => props.$taken ? 'transparent' : 'var(--accent)'};
  box-shadow: ${props => props.$taken ? 'inset 0 0 0 1.5px var(--muted)' : 'none'};
`;

export const TurnDot = styled.i`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--accent);
  box-shadow: 0 0 0 3px rgba(255, 203, 5, .25);
`;
